import _ from "lodash";
import ImageLinks from "../../assets/Images/ImagesLink";
import { useNavigate } from "react-router-dom";

export default function AddressItem({ item, set_delete_confirm }) {
  const navigate = useNavigate();
  const handleAddressClick = () => {
    navigate(`/address/${item.id}`);
  };
  return (
    <div className="shadow-[0px_0px_4px_0px_rgba(166,166,166,0.25)] rounded-[20px] py-3 px-4" onClick={handleAddressClick}>
      <div className="flex justify-between items-center mb-1 gap-2">
        <div className="w-[90%] overflow-hidden flex justify-between items-center">
          <p className="truncate font-custom text-sm font-bold text-black">
            {item?.address_line1}
          </p>
          {!_.isEmpty(item?.label) && (
            <div className="py-[3px] px-[8px] rounded-[40px] bg-accents flex items-center justify-center min-w-[80px] max-w-[80px] overflow-hidden">
              <p className="truncate font-custom font-medium text-[10px] text-secondary">
                {item?.label}
              </p>
            </div>
          )}
        </div>
        <div className="ml-2">
          <img
            src={ImageLinks.bin_black}
            alt="delete"
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              set_delete_confirm({
                open: true,
                id: item.id,
              });
            }}
          />
        </div>
      </div>

      <div className="w-[90%]">
        <p className="text-[#666666] text-xs font-medium mb-1 line-clamp-1">
          {item.google_maps_address}
        </p>
        {item?.poc && (
          <p className="text-xs text-[#1E1E1E] font-medium">
            {item.poc[0]?.name} <span className="mx-2 text-[#C4C4C4]">|</span>
            {item.poc[0]?.mobile}
          </p>
        )}
      </div>
    </div>
  );
}
